import https from 'node:https';

import chalk from 'chalk';
import {CURRENT_VERSION} from 'src/version';

export const getCurrentVersion = (): string => {
  try {
    return CURRENT_VERSION;
  } catch {
    return 'unknown';
  }
};

export const getLatestVersion = (pkgName: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    https
      .get(`https://registry.npmjs.org/${pkgName}/latest`, (res) => {
        let data = '';

        res.on('data', (chunk) => (data += chunk));
        res.on('end', () => {
          try {
            const parsed = JSON.parse(data);

            resolve(parsed.version);
          } catch (err) {
            reject(err);
          }
        });
      })
      .on('error', reject);
  });
};

export const showVersion = async (): Promise<void> => {
  const current = getCurrentVersion();
  let latest: string;

  try {
    latest = await getLatestVersion('@miregma/miregen');
  } catch {
    latest = chalk.red('failed to fetch');
  }

  process.stdout.write(
    `${chalk.blue('Miregen CLI')}\n` +
      `Current: ${chalk.yellow(current)}\n` +
      `Latest: ${chalk.green(latest)}\n`
  );

  if (latest !== 'failed to fetch' && latest !== current) {
    process.stdout.write(chalk.magenta(`Update available: npm install -g miregen@latest\n`));
  }
};
